import { render } from "./RoutesContent.vue?vue&type=template&id=f3d5f03c&ts=true"
import script from "./RoutesContent.vue?vue&type=script&lang=ts"
export * from "./RoutesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__